import styled from '@emotion/styled'

import LocalizedLink from '../LocalizedLink'

import { Col as DefaultCol, Row as DefaultRow } from '../UI/Grid'

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  padding: 0 16px;
`

export const InnerWrapper = styled.div`
  width: 100%;
  max-width: 1200px;
  padding-top: 80px;
`

export const Hero = styled.div`
  background-image: url(${({ src }) => src});
  background-repeat: no-repeat;
  background-size: cover;
  min-height: 406px;
`

export const Link = styled(LocalizedLink)`
  font-size: 0.8rem;
  font-weight: bold;
  margin-right: 32px;
  text-transform: uppercase;
  letter-spacing: 2px;
  line-height: 1.5rem;

  :hover {
    color: ${({ theme }) => theme.colors.orange};
  }
  &.NavLink__currentPath {
    color: ${({ theme }) => theme.colors.orange};
    border-bottom: 2px solid ${({ theme }) => theme.colors.orange};
  }
  @media (max-width: ${props => props.theme.breakpoints.m}) {
    white-space: nowrap;
  }
`
export const NavCategories = styled.div`
  display: flex;
  justify-content: flex-start;
  padding: 32px 0;

  @media (max-width: ${props => props.theme.breakpoints.m}) {
    overflow: scroll;
  }
`

export const Col = styled(DefaultCol)``

export const TextCol = styled(Col)`
  max-width: 800px;
`

export const Row = styled(DefaultRow)`
  position: relative;
`

export const Text = styled.div`
  font-size: 0.9rem;
  color: ${({ theme }) => theme.colors.black};
  line-height: 2rem;

  padding: 32px 0;
`
export const Title = styled.h2`
  font-size: 2rem;
  line-height: 1.4;

  font-weight: bold;
  color: ${({ theme }) => theme.colors.black};

  @media (max-width: ${props => props.theme.breakpoints.m}) {
    font-size: 1.4rem;
  }
  @media (max-width: ${props => props.theme.breakpoints.s}) {
    font-size: 1.25rem;
  }
`

export const Bubbles = styled.img`
  position: absolute;
  top: -80px;
  right: 0;
  max-width: 156px;

  @media (max-width: ${props => props.theme.breakpoints.m}) {
    display: none;
  }
`

export const Card = styled.div`
  height: 100%;
  width: 100%;
  background: ${({ theme }) => theme.colors.bg};
  border: 1px solid #ecebf5;
  box-shadow: 0 2px 16px 0 rgba(21, 30, 41, 0.06);
  border-radius: 4px;
  padding: 20px;
`

export const CardThumb = styled.div`
  background-image: url(${({ src }) => src});
  width: 100%;
  min-height: 210px;
`

export const CardLabel = styled.span`
  display: inline-block;
  font-size: 0.7rem;
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  color: ${({ theme }) => theme.colors.orange};
  border-bottom: 1px solid ${({ theme }) => theme.colors.orange};
  padding: 16px 0 0;
`

export const List = styled.ul`
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  width: 100%;

  list-style-type: none;
  margin-left: 0;
`

export const Item = styled.li`
  position: relative;
  max-width: calc(100% / 3 - 16px);
  min-height: 416px;
  height: 100%;
  width: 100%;
  margin-right: 1.45rem;

  margin-bottom: 1.45rem;
  border-radius: 4px;

  :nth-of-type(3n) {
    margin-right: 0;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.m}) {
    max-width: 100%;
    min-height: 260px;
    margin-right: 0;
  }
`

export const ImageWrapper = styled.div`
  overflow: hidden;
  min-height: 210px;
  width: 100%;
`
export const BackgroundImage = styled.div`
  height: 100%;
  width: 100%;
  min-height: 210px;
  background-image: url(${({ src }) => src});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  border-radius: 4px;

  transition: all 0.3s ease-in-out;

  :hover {
    transform: scale(1.2);
  }
`
export const Headline = styled.p`
  font-size: 1.2rem;
  font-weight: bold;
  padding-top: 16px;
  color: ${props => props.theme.colors.black};
  margin-bottom: 0;

  @media (max-width: ${({ theme }) => theme.breakpoints.s}) {
    font-size: 1.5rem;
  }
`

export const StyledLink = styled(LocalizedLink)`
  :hover {
    ${BackgroundImage} {
      transform: scale(1.2);
    }
  }
`

export const Description = styled.p`
  font-size: 0.8rem;
  color: ${({ theme }) => theme.colors.black};
  padding: 16px 0;
`

export const Date = styled.p`
  font-size: 0.6rem;
  font-weight: bold;
  color: ${({ theme }) => theme.colors.black};
  letter-spacing: 2px;
`
